module.exports = __webpack_public_path__ + "static/media/spaceage.ce43c656.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/spaceage.ttf
// module id = 90
// module chunks = 0